import { Link } from "@mui/material";
import TkButton from "../../../components/atoms/TkButton";
import "../_style.scss";
import { IWamUserListProps } from "../../../type/apiType/IAPI_ACC011";
/**
 * レスポンスデータをテーブルデータに変換する
 * @param res レスポンスデータ
 * @param handleLink 遷移するイベント
 * @param handBtn 詳細ボタン押下イベント
 * @param resultType 検索結果表示対象
 * @returns テーブルデータ
 */
function funInfoBodyList(
  list: IWamUserListProps[],
  handBtn: (userId: string) => void,
  handleLink: (userId: string) => void
) {
  const infoBodyList = list?.map((item) => [
    {
      children: item.userId,
      forSort: item.userId,
      width: 200,
    },
    {
      children: (
        <Link
          data-testid="SCRW120002TableDataContractorLinkForTest"
          onClick={() => handleLink(item.userId!)}
        >
          {item.name}
        </Link>
      ),
      forSort: item.name,
      width: 200,
    },
    {
      children: item.mainDivision,
      forSort: item.mainDivision,
    },
    {
      children: item.mainUnit,
      forSort: item.mainUnit,
    },
    {
      children: item.titleClass,
      forSort: item.titleClass,
    },
    {
      children: item.role,
      forSort: item.role,
    },
    {
      children: <TkButton onClick={() => handBtn(item.userId!)}>削除</TkButton>,
      align: "center",
    },
  ]);

  return infoBodyList;
}

export { funInfoBodyList };
